import { Component, Input } from '@angular/core';

@Component({
  selector: 'loading',
  template: `
    <div class="loader">
      <div>
        <span class="icon-mark"></span>
        <span class="icon-mark"></span>
        <span class="icon-mark"></span>
      </div>
      <span>{{ message }}</span>
    </div>
    `
})
export class LoadingComponent {
  @Input() message: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/loading-indicator/loading-indicator.component.ts